/**
 * Single source of truth for "our backend" for the purpose of the Os-App-Version header.
 * Used by the SPA app (middleware, osFetch), opensolar-pageeditor (axios http.os), and opensolar-sdk
 * so that backend requests are identified and not throttled as external API calls.
 */

/** External URLs that don't support CORS preflight for custom headers (e.g. content.opensolar.com). */
export const BACKEND_EXCLUDED_DOMAINS = ['content.opensolar.com']

/** Only OSAPI and related services expect this header. */
export const BACKEND_INCLUDED_DOMAINS = ['opensolar.com', 'sunsuite.com.au', 'localhost', '127.0.0.1']

/**
 * Returns true when the URL's hostname matches an included domain and not an excluded domain.
 * Use for full URLs or absolute URLs; for relative paths, callers should resolve against
 * window.API_BASE_URL or similar before calling.
 */
export function shouldAddOsAppVersionHeader(url: string): boolean {
  return url.startsWith(window.API_BASE_URL || '')
}

/**
 * Returns the value to set for the Os-App-Version header.
 * In the app and pageeditor, window.SPA_VERSION is set by the host; otherwise falls back to 'spa'.
 */
export function getOsAppVersionHeaderValue(): string {
  return (typeof window !== 'undefined' && (window as any).SPA_VERSION) || 'spa'
}
